import { render, staticRenderFns } from "./ColumnLocation.vue?vue&type=template&id=42757582"
import script from "./ColumnLocation.vue?vue&type=script&lang=js"
export * from "./ColumnLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports